export class DelayEvent {
    constructor(
        delayEventId: number,
        eventTypeId: number,
        delayEventTypeStartId: number,
        delayEventTypeStopId: number,
        delayStartEventTypeInputId: number,
        delayStopEventTypeInputId: number
    ) {
        this.delayEventId = delayEventId;
        this.eventTypeId = eventTypeId;
        this.delayEventTypeStartId = delayEventTypeStartId;
        this.delayEventTypeStopId = delayEventTypeStopId;
        this.delayStartEventTypeInputId = delayStartEventTypeInputId;
        this.delayStopEventTypeInputId = delayStopEventTypeInputId;
    }
    delayEventId: number;
    eventTypeId: number;
    delayEventTypeStartId: number;
    delayEventTypeStopId: number;
    delayStartEventTypeInputId: number;
    delayStopEventTypeInputId: number;
}
